module.exports = __webpack_public_path__ + "static/Spartan-Logo-0307d76083e051d58f619bdb0a9c0b09.png";